import { connect } from 'react-redux';
import {
  detectLanguage,
} from './translation-modal-actions';
import OriginalSection from '../components/original-section';

const mapStateToProps = state => ({
  translatorLanguages: state.translator.translatorLanguages,
  isLoading: state.translator.isLoading,
  isDetecting: state.translator.isDetecting,
  detectedLanguage: state.translator.detectedLanguage,
  locale: state.languageProvider.locale,
  tags: state.ticketForm.tags,
});

const mapDispatchToProps = {
  detectLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(OriginalSection);
